import React, { forwardRef } from 'react';
const BackFilled = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 18 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "m0 12 9.75 6v-5.1L18 18V6l-8.25 5.1V6z", fill: "currentColor" }))));
BackFilled.displayName = 'BackFilled';
// @ts-ignore;
const iconData = {
    glyph: BackFilled,
    group: 'media',
};
export default iconData;
